// extracted by mini-css-extract-plugin
export default {"mCard":"dE-z","image":"eE-z","imageNoBackground":"fE-z","imageHasCategory":"gE-z","fullWidth":"hE-z"};